<template>
  <vx-card no-shadow>
    <h2 class="mb-6">Information</h2>
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Active</span>
      </div>
      <div class="vx-col">
        <vs-switch color="success" value="true" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Title</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input
          name="requiredPerformanceScore"
          :value="visit.title"
        />
      </div>
    </div>

  </vx-card>
</template>

<script>
export default {
  components: {},
  props: {
    visit: Object,
  },
  data() {
    return {};
  },
  methods: {},
  created() {
    this.surveySessionId = this.$route.params.surveyId;
  },
};
</script>

<style style="scss" scoped>
</style>